import React from 'react'
import { useEffect } from 'react';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from 'chart.js';
import { Line } from 'react-chartjs-2';

import { getCexPrice } from '@/utils/chainPrice'
import { useState } from 'react';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);


export default function KCharts({ symbol }) {    
  let labels = [];
  const [isShow, setIsShow] = useState(false)
  const [data, setData] = useState(null)
  
  const options = {
    responsive: true,
    borderJoinStyle:'round',
    borderWidth:2,
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: false,
        text: 'Chart.js Line Chart',
      },
    },
    scales: {
      y: { // defining min and max so hiding the dataset does not change scale range
        // min: 20000,
        // max: 25000
      }
    }
  };
  
  const getPrice= async()=>{
    const prices = await getCexPrice(symbol)
    labels = prices.map(i => i.time)    
    let datas = {
      labels,
      datasets: [
        {
          label: '30d',
          data: prices.map((i) => i.price),
          borderColor: '#21B36C',
          backgroundColor: 'transparent',
        }
      ],
    };
    setData(datas)
    setIsShow(true)

  }
  useEffect(() => {
    getPrice(symbol)
  }, [symbol])

  return (
    <div>
      {
        isShow && <Line options={options} data={data} />
      }      
    </div>
  )
}
